<template>
    <div :id="id">
        <v-select v-if="datetime_list.length !== 0"
            v-model="current_datetime"
            :items="datetime_list"
            id="atlas_table_datetime_select"
            class="date_time__select__box"
            item-text="text"
            item-value="value"
            :label="`選擇時間區間`"
            hide-details
        />
        <div class="table">
            <table class="table__container">
                <template v-for="row_date in img_list">
                    <tr>
                        <td v-for="(column, column_index) in row_date" 
                            :key="column_index" 
                            class="table__header table__header__border"
                        >
                            <div class="">
                                {{ column.text }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td v-for="(column, column_index) in row_date" 
                            :key="column_index" 
                        >
                            <div class="">
                                <v-img 
                                    :src="get_src(column.img)"
                                    aspect-ratio="1"
                                    @click="show_detailed_picture(column.img)"
                                    @error="change_src(row_date[column_index].img)"
                                    id="img_id_for_selector"
                                    contain
                                />
                            </div>
                        </td>
                    </tr>
                </template>
            </table>
        </div>
    </div>
</template>
    
<script>
import * as dayjs from 'dayjs'
import { atlas_root_dir, alt_src } from '../../../config/atlas_route_config.js'
import { atlas_newest_data_single_txt_ajax } from '@/utils/atlas/atlas.js'

export default {
    name: 'AtlasTableSingleDate',

    props: {
        id: {
            type: String,
            required: true,
        },

        row_date_count: {
            type: Number,
            default() {
                return 8
            },
        },

        column_date_count: {
            type: Number,
            default() {
                return 5
            },
        },

        images_dir: {
            type: String,
            required: true,
        },

        compression: {
            type: Boolean,
            default() {
                return false
            },
        },

        file_name: {
            type: Object,
            default() {
                return {}
            },
        },
    },

    data() {
        return {
            newest_date: '',
            newest_hour: '',
            img_list: [],

            current_datetime: '',
            datetime_list: [],
        }
    },

    created() {
        this.init_atlas()
    },

    computed: {},

    methods: {
        async init_atlas() {
            const response = await atlas_newest_data_single_txt_ajax(`${atlas_root_dir}${this.images_dir}`)

            const date_split = response.data.split(',')
            this.newest_date = date_split[0]
            this.newest_hour = date_split[1]

            this.generate_time_select_bar()
        },

        generate_images() {
            let calculated_date = new Date(this.newest_date)
            const start_year = calculated_date.getFullYear()
            const start_month = this.fillzero(calculated_date.getMonth() + 1)
            const start_date = this.fillzero(calculated_date.getDate())
            const start_hour = Number(this.newest_hour)

            const list = Array.from({ length: this.column_date_count }).map((o, r) => {
                const year = calculated_date.getFullYear()
                const month = this.fillzero(calculated_date.getMonth() + 1)
                const date = this.fillzero(calculated_date.getDate())
                calculated_date.setDate(calculated_date.getDate() + 1)

                return Array.from({ length: this.row_date_count }).map((o, i) => {
                    const cst = this.fillzero(start_hour + i * 3)
                    const text_date = new Date(`${year}/${month}/${date}`)
                    text_date.setHours(cst)
                    const mm = this.fillzero(text_date.getMonth() + 1)
                    const dd = this.fillzero(text_date.getDate())
                    const tau = this.fillzero(cst % 24)

                    return {
                        year: year,
                        date: month + date,
                        text: `${mm}${dd} ${tau}CST`,
                        img: {
                            src: this.generate_file_name({
                                atlas_root_dir,
                                images_dir: this.images_dir,
                                newest_year: start_year,
                                column_date: start_month + start_date,
                                index: String((r * this.row_date_count + i) * 3).padStart(4, '0'),
                                newest_hour: this.newest_hour,
                            }),
                            alt_image: alt_src,
                            failed: false,
                        },
                    }
                })
            })

            this.img_list = list
        },

        async generate_time_select_bar() {
            const latest_date = this.newest_date + ',' + this.newest_hour

            if (!latest_date) {
                return
            }

            const datetime_list = this.generate_selected_time_list(latest_date)

            const is_current_datetime_need_init = !datetime_list
                .map(({ value }) => value)
                .includes(this.current_datetime)
            this.datetime_list = datetime_list
            if (is_current_datetime_need_init) {
                this.current_datetime = datetime_list[0].value
            }
        },

        generate_selected_time_list(latest_date) {
            const text_format_rule = 'YYYY年MM月DD日HH時'
            const date = latest_date.split(',')[0]
            const hour = latest_date.split(',')[1]
            let now_date = dayjs(date).hour(hour)
            const EACH_TIME_DIFFERENCE = 6 // 下拉選單以 6小時為區間

            return [...Array(20)].map((item, index) => {
                if (index > 0) now_date = dayjs(now_date).add(-EACH_TIME_DIFFERENCE, 'h')
                return {
                    text: dayjs(now_date).format(text_format_rule),
                    value: dayjs(now_date).format('YYYY-MM-DD,HH'),
                }
            })
        },

        generate_file_name({ atlas_root_dir, images_dir, newest_year, newest_hour, column_date, index }) {
            // 202503200200CST_MPB_Warning_Area_Taiwan_tau0000.png
            return `${atlas_root_dir}${images_dir}/${newest_year}${column_date}${newest_hour}${
                this.file_name.prefix
            }${index}${this.file_name.suffix}.${this.file_name.type}`
        },

        fillzero(s) {
            let r = String(s)
            if (r.length < 2) return '0' + r

            return r
        },

        get_src(image, compression) {
            if (image.failed) {
                return image.alt_image
            } else if (image.src == null) {
                return ''
            } else if (compression) {
                let split_items = image.src.split('/')
                split_items[split_items.length - 1] = 'small_' + split_items[split_items.length - 1]
                return split_items.join('/')
            } else {
                return image.src
            }
        },

        change_src(image) {
            image.failed = true
        },

        close_atlas_dialog() {
            this.dialog = false
        },

        maintain_atlas_dialog() {
            event.stopPropagation()
        },

        show_detailed_picture(image) {
            const is_access_enlarge_image = image.src && !image.failed
            is_access_enlarge_image && this.$emit('open-image-dialog', image.src)
        },
    },
    watch: {
        current_datetime: {
            handler(datetime) {
                if (!datetime) return

                const date_split = datetime.split(',')
                this.newest_date = date_split[0]
                this.newest_hour = date_split[1]
                this.generate_images()
            },
            immediate: true,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../../css/mixin';

.table {
    overflow-x: auto;
    overflow-y: hidden;
    margin-top: 0.5rem;
    width: 100%;

    &::-webkit-scrollbar {
        display: none;
    }

    &__container {
        width: 100%;
        border-collapse: collapse;

        @include tablet {
            min-width: 1000px;
        }

        td {
            width: 76px;
            font-size: 14px;
            letter-spacing: 1px;
            line-height: 20px;
            color: var(--base_black);
        }

        tr {
            td:first-child {
                border-left: unset;
            }
            td:last-child {
                border-right: unset;
            }
        }
    }

    &__sidebar {
        font-weight: bold;
        background: var(--white-bg);
        border-top: 2px solid #fff;
        border-left: 2px solid #fff;
        border-right: 2px solid #fff;
    }

    &__header {
        padding: 6px;
        font-weight: bold;
        text-align: center;
        background: var(--white-bg);

        &__border {
            border-top: 2px solid #fff;
            border-right: 2px solid #fff;
            border-bottom: 2px solid #fff;
        }

        &__first {
            border: 2px solid #fff;
        }
    }
}
</style>
